import React from 'react';
import HistoryIcon from '@mui/icons-material/History';
import { Badge } from '@mui/material';

import { useAppMonitor } from '../../../monitor';
import { getActiveAnalysisSet } from '../../../store/selectors/getActiveAnalysisSetSelector';
import { getActiveComponentDesign } from '../../../store/selectors/getActiveComponentDesignSelector';
import { getAnalysisHistoryForActiveComponentDesign } from '../../../store/selectors/getAnalysisHistoryForActiveComponentDesignSelector';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { isViewingOldAnalysisSet } from '../../../store/selectors/viewOnlyModeSelectors';
import { leftSidebarSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function AnalysisHistoryButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const inLayoutMode = useAppSelector(isLayoutViewActive);
  const open = useAppSelector((state) => state.panelData.leftSidebar === 'analysisHistory');

  const viewingOldAnalysisSet = useAppSelector(isViewingOldAnalysisSet);
  const historyForActiveComponentDesign = useAppSelector(getAnalysisHistoryForActiveComponentDesign);

  const flaggedForOverCapacity = useAppSelector((state) => {
    const activeAnalysisSet = getActiveAnalysisSet(state);
    const activeComponentDesign = getActiveComponentDesign(state);

    if (activeAnalysisSet == null || activeComponentDesign == null) return false;

    // not sure when this would happen but `createGetCapacityColorForComponent` has this check so monkey see monkey do
    if (activeAnalysisSet.componentDesign.guid !== activeComponentDesign.guid) return false;

    return activeAnalysisSet.capacity > 1 || activeAnalysisSet.errors.length > 0;
  });

  if (inLayoutMode) return null;

  return (
    <ToolbarIconButton
      title="Analysis and History"
      icon={
        <Badge
          variant="dot"
          color={flaggedForOverCapacity ? 'error' : 'secondary'}
          invisible={!viewingOldAnalysisSet && !flaggedForOverCapacity}
        >
          <HistoryIcon />
        </Badge>
      }
      onClick={() => {
        dispatch(leftSidebarSet(open ? 'open' : 'analysisHistory'));
        monitor.recordInteraction('Analysis History Panel Opened');
      }}
      disabled={historyForActiveComponentDesign === null || historyForActiveComponentDesign.length === 0}
    />
  );
}
